<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete" :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
    // Author Pan Yu Rou
    // Date 2024-12-10 18:05:40

    import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
    import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete.vue";
    import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine.vue";
    import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
    import emApiMixin from "@/mixin/em/common/api";

    export default {
        name: "sithMesPrdZpp2WorkflowTaskView",
        components: {WorkflowProcessLine, WorkflowTaskComplete},
        mixins: [emWorkflowTaskMixin, workflowTaskMixins, emApiMixin],
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            },
            materialNumbersDetailFields() {
                return [
                    {
                        key: 'MATERIAL_NUMBER',
                        label: '物料编码'
                    },
                    {
                        key: 'QUANTITY',
                        label: '数量',
                        format: 'number'
                    },
                ]
            },
            config() {
                return {
                    'task1': {
                        name: '申请创建工单及维护工艺流程',
                        variables: [
                            {
                                label: '发起或结束流程',
                                type: this.VALUE_TYPE.SELECT,
                                saveTo: this.SAVE_TO.APPROVE,
                                options: [
                                    {value: 1, text: '发起流程'},
                                    {value: 2, text: '结束流程'}
                                ],
                            },
                            {
                                needTag: 'needApprove',
                                name: 'materialNumbersDetail',
                                type: this.VALUE_TYPE.TABLE,
                                fields: this.materialNumbersDetailFields,
                                entityName: 'sithMesPrdZpp2MaterialsDetail',
                                filterHolder: {
                                    zpp2IdFilter: this.$_emWorkflowTaskMixin_businessKey,
                                },
                                saveHolder: {
                                    zpp2Id: this.$_emWorkflowTaskMixin_businessKey,
                                }
                            },
                            {
                                label: '备注',
                                name: 'comment',
                                type: this.VALUE_TYPE.TEXTAREA,
                                saveTo: this.SAVE_TO.FLOW,
                                initData: true,
                            }
                        ],
                        changeTag: (_, approve) => {
                            return this.buildTag('needApprove', approve === 1);
                        },
                        userSelectMap: {
                            1: [
                                {
                                    name: 'task2_candidates',
                                    allowMulti: true,
                                    require: true,
                                    labelWithout: '指派工单创建人'
                                }
                            ],
                        },
                        approveToNextTask: {
                            1: 'task2',
                            2: 'EndEvent'
                        },
                    },
                    'task2': {
                        name: '工单创建释放流程',
                        variables: [
                            {
                                label: '审核结果',
                                type: this.VALUE_TYPE.SELECT,
                                saveTo: this.SAVE_TO.APPROVE,
                                options: [
                                    {value: 1, text: '通过'},
                                    {value: 2, text: '退回'}
                                ],
                                require: true,
                            },
                            {
                                needTag: 'needApprove',
                                label: '工单号',
                                name: 'orderCode',
                                type: this.VALUE_TYPE.INPUT,
                                saveTo: this.SAVE_TO.DATABASE,
                                require: true,
                            },
                            {
                                label: '备注',
                                name: 'comment',
                                type: this.VALUE_TYPE.TEXTAREA,
                                saveTo: this.SAVE_TO.FLOW,
                                initData: true,
                            }
                        ],
                        changeTag: (_, approve) => {
                            return this.buildTag('needApprove', approve === 1);
                        },
                        userSelectMap: {
                            '1': [
                                {
                                    name: 'task3_candidates',
                                    allowMulti: true,
                                    require: true,
                                    labelWithout: '指派配图工艺员'
                                }
                            ]
                        },
                        approveToNextTask: {
                            1: 'task3',
                            2: 'task2'
                        },
                    },
                    'task3': {
                        name: '工艺员配图流程',
                        variables: [
                            {
                                label: '审核结果',
                                type: this.VALUE_TYPE.SELECT,
                                saveTo: this.SAVE_TO.APPROVE,
                                options: [
                                    {value: 1, text: '通过'},
                                    {value: 2, text: '退回'}
                                ],
                            },
                            {
                                needTag: 'needApprove',
                                label: '是否有需要上传的图纸及文件',
                                name: 'needUploadAttachment',
                                type: this.VALUE_TYPE.SELECT,
                                saveTo: this.SAVE_TO.DATABASE,
                                options: [
                                    {value: true, text: '是'},
                                    {value: false, text: '否'},
                                ],
                                require: true,
                            },

                            {
                                label: '备注',
                                name: 'comment',
                                type: this.VALUE_TYPE.TEXTAREA,
                                saveTo: this.SAVE_TO.FLOW,
                                initData: true,
                            }
                        ],
                        changeTag: (_, approve) => {
                            return this.buildTag('needApprove', approve === 1);
                        },
                        userSelectMap: {
                            '1': [
                                {
                                    name: 'task4_candidates',
                                    allowMulti: true,
                                    require: true,
                                    labelWithout: '指派工单技术关闭人'
                                }
                            ]
                        },
                        approveToNextTask: {
                            1: 'task4',
                            2: 'task2'
                        },
                    },
                    'task4': {
                        name: '工单关闭流程ZPP2',
                        variables: [
                            {
                                label: '审核结果',
                                type: this.VALUE_TYPE.SELECT,
                                saveTo: this.SAVE_TO.APPROVE,
                                options: [
                                    {value: 1, text: '通过'},
                                    {value: 2, text: '退回'}
                                ],
                            },
                            {
                                label: '备注',
                                name: 'comment',
                                type: this.VALUE_TYPE.TEXTAREA,
                                saveTo: this.SAVE_TO.FLOW,
                                initData: true,
                            }
                        ],
                        approveToNextTask: {
                            1: 'EndEvent',
                            2: 'task3'
                        },
                    },
                    'EndEvent': {
                        name: '结束'
                    }
                }
            }
        },
    };
</script>